import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import App from './app/App';
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";
import packageJson from '../package.json';
import config from "./config";
const appVersion = packageJson.version;

Sentry.init({
    dsn: `${config.sentryDSN}1`,
    tunnel: `1/log`,
    release: appVersion,
    integrations: [
        new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 0.0,
    enableTracing: false,
    autoSessionTracking: false,
    replaysOnErrorSampleRate: 1.0,
    
    beforeSend(event, hint) {
        if (hint?.originalException instanceof Error) {
            // Modify the event object to include request payload and response
            let payloads = {
                url: hint?.originalException?.config?.url,
                method: hint?.originalException?.config?.method,
                data: hint?.originalException?.config?.data,
                headers: hint?.originalException?.config?.headers,
            };
            let respond = {
                status: hint?.originalException?.response?.status,
                data: hint?.originalException?.response?.data,
            };
            event.request = {
                ...event?.request,
                originalException: hint?.originalException,
                req_payload: payloads,
                req_respond: respond
            }
            return event
        }
        return null;
    }
});

Sentry.setContext('package', {
    version: appVersion,
});

const originalConsoleError = console.error;
console.error = function (...message) {
    Sentry.captureMessage(new Error('[Console Error] ' + message.join(' ')));
    originalConsoleError.apply(console, message);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))  
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);